import { z } from "zod/v4";

export const clientScheme = z
  .string("bookingV3.filterClient.clientMandatory")
  .nonempty("bookingV3.filterClient.clientMandatory");
